<div class="auth-flex-container">
  <div class="form-wrapper">
    <div class="form-header-wrapper">
      <h2 class="form-header-text">Session expired.</h2>
      <div>Please try refreshing your browser and logging in again.</div>
      <div><strong>Need assistance? Contact our help desk at 1-800-282-7648</strong></div>
    </div>
  </div>
</div>

